<template>
   <div class="formsinglecheck">
    <div class="checktitle"> <span >{{property.name}}</span><span v-if="property.checked" class="ischeck">*</span></div>
    <div class="formcheckbox">
      <div class="item" v-for="(item,index) in property.list" :key="index">
        <span class="radioicon2"></span>
        <span class="radiotxt">{{item.label}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
       form: {}
    };
  }
};
</script>

 